import './_event-delegation';
let $ = jQuery

export default class Pagination {
  constructor ({postsWrapper = '.post-grid', paginationWrapper = '#posts-pagination', paginationItem = 'li a', action = 'filter_posts', loadingWrapper = '.post-grid', loadingClass = 'loading'} = {}) {
    this.postsWrapper = postsWrapper;
    this.paginationWrapper = paginationWrapper;
    this.paginationItem = paginationItem;
    this.action = action;
    this.loadingWrapper = loadingWrapper;
    this.loadingClass = loadingClass;
    this.postType = 'post';
    this.loading = false;
    this.postsPerPage = 0;
    this.pageNumber = 0;
    this.hasListeners = false;
    this.searchPage = false;
    this.taxonomy = '';
    this.terms = '';
  }

  init () {
    if (document.querySelector(this.paginationWrapper) && this.isSearchPage() === false) {
      this.setPostsPerPage();
      this.setPostType();

      if (this.hasListeners === false) {
        this.addListeners();
      }
    }
  }

  addListeners () {
    document.querySelector(this.paginationWrapper).on('click', this.paginationItem, (e, el) => {
      e.preventDefault();

      if (this.validateItem(el)) {
        this.startLoading();
        this.setPageNumber(el);
        this.setPostType();
        this.setPostsPerPage();
        this.fetchData();
      }
    });

    this.hasListeners = true;
  }

  /**
   * Loading
   */
  startLoading () {
    this.loading = true;
    document.querySelector(this.loadingWrapper).classList.add(this.loadingClass);
  }
  
  stopLoading () {
    this.loading = false;
    document.querySelector(this.loadingWrapper).classList.remove(this.loadingClass);
  }

  /**
   * Handle data
   */
  validateItem (item) {
    return item.classList.contains('disabled') || item.classList.contains('active') ? false : true;
  }

  getPageNumber (item) {
    return item.getAttribute('data-pagination-page');
  }

  getPostType () {
    return document.querySelector(this.paginationWrapper).getAttribute('data-pagination-post-type');
  }

  getPerPage () {
    return document.querySelector(this.paginationWrapper).getAttribute('data-pagination-per-page');
  }

  setPageNumber (item) {
    this.pageNumber = this.getPageNumber(item);
  }

  setPostType () {
    this.postType = this.getPostType();
  }

  setPostsPerPage () {
    this.postsPerPage = this.getPerPage();
  }

  isSearchPage () {
    return document.querySelector(this.paginationWrapper).querySelector('ul') === null;
  }

  setTaxonomy(taxonomy) {
    this.taxonomy = taxonomy;
  }

  setTerms(terms) {
    this.terms = terms;
  }

  resetPageNumber() {
    this.pageNumber = 0;
  }

  /**
   * URL parameters
   */
  setUrlParameters () {
    window.history.pushState('pagination', '', `?perpage=${this.postsPerPage}&pagenumber=${this.pageNumber}${this.taxonomy && this.terms ? '&taxonomy=' + this.taxonomy : ''}${this.terms ? '&terms=' + this.terms : ''}`);
  }

  /**
   * Ajax call
   */
  fetchData () {
    $('html, body').animate({ scrollTop: $(this.postsWrapper).offset().top - 200}, 500);

    const DATA = {
      action: this.action,
      post_type: this.postType,
      page_number: this.pageNumber,
      posts_per_page: this.postsPerPage,
      url: window.location.href,
      taxonomy: this.taxonomy,
      terms: this.terms
    };

    $.post(main_theme_objects.ajax_url, DATA, (response) => {
      if (response != 0) {
        document.querySelector(this.postsWrapper).innerHTML = response.posts;
        document.querySelector(this.paginationWrapper).innerHTML = response.pagination;
        this.setUrlParameters();
      }
    }).always(() => {
      this.stopLoading();
    });
  }
}